<template>
	<div
		v-editable="blok"
		class="relative"
		:class="{
			'row-span-1 col-span-3 lg:row-span-3 lg:col-span-1 md:row-span-2 md:col-span-2' : large,
			'row-span-3 col-span-3' : horizontal
		}"
	>
		<div
			class="
				overflow-hidden group grid shadow-md rounded-xl border border-border-tertiary bg-white relative h-full items-center
				md:grid-cols-[70%_30%]
			"
			:class="{
				'grid-cols-[70%_30%]': large,
				'max-md:flex max-md:flex-col': !large,
			}"
		>
			<div
				class="px-2 py-5 md:px-4 max-md:grow max-md:flex max-md:items-center"
				:class="{
					'py-8' : large,
					'text-center md:text-left' : !large,
				}"
			>
				<h3 class="typo-h5 md:typo-h3 text-heading-secondary break-words xs:break-normal">
					<AbsoluteInternalLink
						:to="blok.url.cached_url"
						:target="blok.url.target"
						class="before:cover-parent focus-outline"
					>
						{{ blok.title }}
					</AbsoluteInternalLink>
				</h3>
			</div>
			<div class="relative w-full md:h-full aspect-square md:aspect-auto max-md:mt-auto">
				<NuxtPicture
					v-if="blok.image?.filename"
					class="absolute right-0 clip-style block h-full w-full"
					:class="{'max-md:clip-style-top': !large}"
					provider="storyblok"
					height="200"
					width="200"
					:modifiers="storyblokFocusModifiers(blok.image.focus)"
					:src="blok.image.filename"
					:alt="blok.image.alt || ''"
					sizes="inf:200px"
					:img-attrs="{class:'w-full h-full object-cover'}"
				/>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
	import type {CategoryStackItemStoryblok} from '@/storyblok/types';

	defineProps({
		blok: {
			type: Object as PropType<CategoryStackItemStoryblok>,
			required: true,
			default: () => {},
		},
		large: {
			type: Boolean,
			default: false,
		},
		horizontal: {
			type: Boolean,
			default: false,
		},
	});
</script>
